const LinkHook = (props) => {
    return(
        <a target={props.target} className={props.className ? props.className : ''} style={props.style} href={props.href}>{props.text}</a>
    );
}
export default LinkHook